const OurStats = () => {
  return (
    <section
      id="counter"
      className="section-padding bg-image overlay-dark dark-bg"
      data-stellar-background-ratio="0.5"
      data-background-img="/img/full/14.jpg"
    >
      <div className="container text-center">
        <h3>Stats That Matter</h3>
        <br />
        <div className="row">
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-lightbulb" />
            </div>
            <h1 className="counter-title counter-num">50</h1>
            <h5 className="counter-sub-title">
              Custom ERP Solutions Developed for SMBs and Enterprises
            </h5>
          </div>
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-case" />
            </div>
            <h1 className="counter-title counter-num">25</h1>
            <h5 className="counter-sub-title">
              Industry Verticals including Manufacturing, Retail, and Services
            </h5>
          </div>
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-heart" />
            </div>
            <h1 className="counter-title counter-num">100%</h1>
            <h5 className="counter-sub-title">
              Client Retention Rate Based on Trust, Quality, and Results
            </h5>
          </div>
          <div className="col-md-3 col-sm-6 mb-sm-30">
            <div className="alt-icon-top counter-icon">
              <i className="icon icon-basic-cup" />
            </div>
            <h1 className="counter-title counter-num">13+</h1>
            <h5 className="counter-sub-title">
              Years of Combined Experience Across AI, ERP, and Cloud Systems
            </h5>
          </div>
        </div>
      </div>
    </section>
  );
};
export default OurStats;
